import React from "react";
import { StyledDashboardCard, DASH_BOARD_STYLE_MAPPINGS } from "./styles";
import GroupIcon from "@mui/icons-material/Group";
import PublishIcon from "@mui/icons-material/Publish";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import WorkHistoryIcon from "@mui/icons-material/WorkHistory";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import HourglassBottomIcon from "@mui/icons-material/HourglassBottom";
import LuggageIcon from "@mui/icons-material/Luggage";

const DashBoardTile = ({ title, text, variant, isClickable = false,onTileClick=()=>{} }) => {
  const mappingColor =
    DASH_BOARD_STYLE_MAPPINGS[variant] || DASH_BOARD_STYLE_MAPPINGS["DEFAULT"];

  const getIcon = (value) => {
    switch (value) {
      case "Employees":
        return <GroupIcon />;
      case "Submitted":
        return <PublishIcon />;
      case "Pending":
        return <HourglassBottomIcon />;
      case "Total Hours":
        return <AccessTimeIcon />;
      case "Approved Hours":
        return <CheckCircleIcon />;
      case "Holiday/Vacation":
        return <LuggageIcon />;
      default:
        return <WorkHistoryIcon />;
    }
  };
  return (
    <StyledDashboardCard
      onClick={() => {
        if (isClickable) {
          onTileClick(title);
        }
      }}
      style={{ cursor: isClickable ? "pointer" : "default" }}
      backgroundcolor={mappingColor}
      textcolor={mappingColor}
    >
      <div className="hours">
        <div className="tma_db_icon">{getIcon(title)}</div>
      </div>
      <div className="content">
        <p className="tma_db_tile_text">{text}</p>
        <header className="tma_db_tile_title">{title}</header>
      </div>
    </StyledDashboardCard>
  );
};

export default DashBoardTile;
